<template>
  <!-- 荣誉殿堂 我的证书 -->
  <div class="index-container">
    <bannerImg :bannerText="bannerText" :isShowTab="true"></bannerImg>
    <personalSidebar>
      <div class="right-content">
        <div class="r-title">{{ bannerText }}</div>
        <div class="card-box">
          <div
            class="card-list"
            v-for="(item, index) in cardList"
            :key="'card' + index"
            @click="lookCard(item)"
          >
            <div
              class="card-img"
              :style="{ backgroundImage: 'url( ' + imgUrl + item.template + ')' }"
            ></div>
            <div class="card-title">{{ item.title }}</div>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :page-size="page_size"
          :total="listTotal"
        ></el-pagination>
      </div>
    </personalSidebar>
    <!-- 查看证书 -->
    <el-dialog class="form-box" :visible.sync="dialogVisible" width="600PX">
      <div class="dialog-img" :style="{ backgroundImage: 'url( ' + imgUrl + info.template + ')' }"></div>
      <div class="d-title">{{ info.title }}</div>
      <div class="download-btn" @click="downloadCard">下载证书</div>
    </el-dialog>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import personalSidebar from '../components/personalSidebar.vue';
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'myCard',
  components: {
    bannerImg,
    personalSidebar
  },
  data() {
    return {
      imgUrl: imgUrl,
      bannerText: '个人中心',
      cardList: [],
      dialogVisible: false,
      info: {
        template: '',
        title: ''
      },
      type: '1',
      page_size: 9,
      page_index: 1,
      listTotal: 0
    };
  },
  watch: {
    type() {
      return this.$route.query.name.name === '荣誉殿堂' ? '1' : '2';
      console.log(this.type);
    }
  },
  mounted() {
    scrollTo(0, 0);
    const name = this.$route.query;
    console.log(name);
    this.type = name.name === '荣誉殿堂' ? '1' : '2';
    this.bannerText = name ? name.name : '个人中心';
    this.getHornorList();
  },
  methods: {
    // 页码改变
    handleCurrentChange(val) {
      this.page_index = val;
      this.getHornorList();
    },
    //   下载证书
    downloadCard() {
      window.location.href = imgUrl + this.info.template;
    },
    lookCard(item) {
      this.info = item;
      this.dialogVisible = true;
    },
    getHornorList() {
      const params = {
        type: this.type,
        page_size: this.page_size,
        page_index: this.page_index
      };
      api.getHornorList(params).then(res => {
        console.log(res);
        this.cardList = res.result.data;
        this.listTotal = res.result.total;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  padding-bottom: 2PX;
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.right-content {
  width: 72%;
  padding: 32PX 30PX;
  background-color: #ffffff;
  box-shadow: 0PX 3PX 16PX 0PX rgba(228, 228, 228, 0.35);
  border-radius: 10PX;
}
.r-title {
  padding-bottom: 38PX;
  font-size: 20PX;
}
.card-box {
  display: flex;
  flex-wrap: wrap;
  //   justify-content: space-between;
  .card-list {
    width: 30%;
    padding: 10PX 4PX 0;
    // margin-bottom: 16PX;
    margin: 0 8PX 16PX;
    cursor: pointer;
    &:hover {
      background-color: rgba($color: #f3f2f2, $alpha: 0.7);
      .card-title {
        color: #f1a475;
      }
    }
  }
  .card-img {
    width: 100%;
    height: 224PX;
    margin: 0 auto;
    background-color: #f1a475;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .card-title {
    padding: 18PX;
    font-size: 16PX;
    color: #888888;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.dialog-img {
  width: 90%;
  height: 445PX;
  margin: 0 auto 26PX;
  background-color: #f1a373;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.d-title {
  padding-bottom: 46PX;
  font-size: 22PX;
  text-align: center;
}
.download-btn {
  width: 52%;
  margin: 0 auto;
  font-size: 18PX;
  color: #ffffff;
  line-height: 65PX;
  text-align: center;
  background-color: #f1a373;
  border-radius: 45PX;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
/deep/ {
  .el-dialog {
    padding: 0 20PX 0;
    border-radius: 9PX;
  }
}
/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    margin-top: 80PX;
    text-align: center;
    button {
      width: 42PX;
      height: 42PX;
    }
  }
  .el-pager li {
    width: 42PX;
    height: 42PX;
    line-height: 42PX;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myCard.vue